import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import styles from './TrialDemoCompactBanner.module.css';

/**
 * Faixa única do celular: teste e dados de exemplo numa linha ("30 dias · com exemplos"),
 * com Assinar à vista e Remover no menu (R5: o menu só aparece para quem pode remover).
 * O estado vem de DemoDataBanner (useTrialDemoCompact + useDemoDataRemoval).
 */
const TrialDemoCompactBanner = ({ trial, canRemove, removing, onRemove }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleRemove = () => {
    setAnchorEl(null);
    onRemove();
  };

  return (
    <div className={styles.banner} data-tour="demo-banner">
      <span className={styles.message}>
        <span className={styles[trial.urgency]}>{trial.tinyMessage}</span>
        {' · com exemplos'}
      </span>
      <button type="button" className={styles.ctaButton} onClick={() => navigate('/subscription/plans')}>
        Assinar
      </button>
      {canRemove && (
        <>
          <IconButton
            size="small"
            aria-label="Mais opções dos dados de exemplo"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            disabled={removing}
            sx={{ color: '#92400E', padding: '4px' }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={handleRemove} sx={{ fontSize: '0.875rem' }}>
              Remover dados de exemplo
            </MenuItem>
          </Menu>
        </>
      )}
    </div>
  );
};

export default TrialDemoCompactBanner;
